import React, { useEffect, useRef } from "react";
import { FaTimes } from "react-icons/fa";

import { loadGoogleMapsWithDrawingLibraries } from "../../utils/googleMapsDrawing";

import "./FieldAppPoiMapModal.css";

const KIND_COLORS = {
  toco: "#2E7D32",
  pedra: "#6D4C41",
  valeta: "#0277BD",
  buraco: "#EF6C00",
  outro: "#1B5E20",
  besta: "#0277BD",
};

export default function FieldAppPoiMapModal({ points, title, onClose, t }) {
  const mapRef = useRef(null);

  useEffect(() => {
    let cancelled = false;
    const markers = [];

    async function init() {
      try {
        await loadGoogleMapsWithDrawingLibraries();
      } catch (error) {
        return;
      }
      if (cancelled || !mapRef.current || !window.google || !window.google.maps) {
        return;
      }

      const maps = window.google.maps;
      const valid = (points || []).filter(
        (point) => point.lat != null && point.lng != null
      );
      const first = valid[0] || { lat: -15.78, lng: -47.93 };
      const map = new maps.Map(mapRef.current, {
        center: { lat: first.lat, lng: first.lng },
        zoom: valid.length > 1 ? 15 : 17,
        mapTypeId: maps.MapTypeId.HYBRID,
        streetViewControl: false,
        fullscreenControl: true,
        mapTypeControl: false,
      });
      const bounds = new maps.LatLngBounds();

      valid.forEach((point) => {
        const position = { lat: point.lat, lng: point.lng };
        const color = KIND_COLORS[point.kind] || KIND_COLORS.outro;
        const marker = new maps.Marker({
          map: map,
          position: position,
          title: point.label,
          label: {
            text: String(point.label || "?").slice(0, 1).toUpperCase(),
            color: "#fff",
            fontWeight: "700",
          },
          icon: {
            path: maps.SymbolPath.CIRCLE,
            scale: 11,
            fillColor: color,
            fillOpacity: 1,
            strokeColor: "#ffffff",
            strokeWeight: 2,
          },
        });
        const info = new maps.InfoWindow({
          content:
            "<div style='min-width:140px'><strong>" +
            (point.label || t("Ponto de interesse")) +
            "</strong>" +
            (point.note ? "<div>" + point.note + "</div>" : "") +
            "<div>" +
            Number(point.lat).toFixed(6) +
            ", " +
            Number(point.lng).toFixed(6) +
            "</div></div>",
        });
        marker.addListener("click", function onMarkerClick() {
          info.open(map, marker);
        });
        markers.push(marker);
        bounds.extend(position);
      });

      if (valid.length > 1) {
        map.fitBounds(bounds, 56);
      }
    }

    init();

    return function cleanup() {
      cancelled = true;
      markers.forEach((marker) => marker.setMap(null));
    };
  }, [points, t]);

  return (
    <div className="field-app-modal-backdrop" onClick={onClose}>
      <div
        className="field-app-poi-map-modal"
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <div className="field-app-poi-map-header">
          <h3>{title || t("Pontos de interesse")}</h3>
          <button
            type="button"
            className="btn btn-default btn-sm"
            onClick={onClose}
          >
            <FaTimes aria-hidden /> {t("Fechar")}
          </button>
        </div>
        <div ref={mapRef} className="field-app-poi-map-canvas" />
      </div>
    </div>
  );
}
